export default "__VITE_ASSET__BDvp_Ufe__"